import React, { useContext } from 'react';
import {styled} from '@volkswagen-onehub/components-core';
import Lengths from './Lengths';
import Visuals from './Visuals';
import LengthToggle from './LengthToggle';
import { VehicleSelection } from './Selection';
import { VehicleSelectionSkeleton } from './Selection/VehicleSelectionSkeleton';
import { LengthsSkeleton } from './Lengths/LengthsSkeleton';
import { LengthToggleSkeleton } from './LengthToggleSkeleton';
import { SelectedAcodesContext } from '../../context/SelectedAcodes';
import { useFeatureAppContent } from '../../use-feature-app-content';
import useTrackResults from '../../hooks/use-track-results';

const AppWrapper = styled.div<{isOnCompareTool: boolean}>`
  margin: 0 auto;
  width: 100%;
  max-width: 2560px;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${({isOnCompareTool, theme}) => !isOnCompareTool && `
    padding: 0 ${theme.size.grid001};
    @media (min-width: 1025px) {
      padding: 0 ${theme.size.grid002};
    }
  `}
`;

const StyledCard = styled.div`
  margin: 0 auto;
  width: 100%;
  overflow: hidden;
  background-color: ${(props) => props.theme.colors.background.tertiary};
  box-shadow: ${(props) => props.theme.colors.shadow.default};
  border-radius: ${(props) => props.theme.size.borderRadius.cardL};
`;

const DimensionContainer = styled.div`
  padding: ${(props) => props.theme.size.grid001};
  display: flex;
  flex-direction: column;
  row-gap: ${(props) => props.theme.size.dynamic0100};
`;

const SelectionWrapper = styled.div`
  padding-top: ${(props) => props.theme.size.grid001};
`;

const LengthsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${(props) => props.theme.size.dynamic0100};
`;

export default () => {

  useTrackResults();

  const isOnCompareTool = useFeatureAppContent().context === "comparetool";
  const {vehicles, isFetching} = useContext(SelectedAcodesContext);

  return (
    <AppWrapper isOnCompareTool={isOnCompareTool}>
      <StyledCard>
        { isOnCompareTool ? null : (
          <SelectionWrapper>
            {isFetching && !vehicles.length ? <VehicleSelectionSkeleton /> : <VehicleSelection />}
          </SelectionWrapper>
        )}
        <DimensionContainer>
          <Visuals vehicles={vehicles} />
          <LengthsWrapper>
            {isFetching && !vehicles.length ? (
              <>
                <LengthsSkeleton />
                <LengthToggleSkeleton />
              </>
            ) : (
              <>
                <Lengths vehicles={vehicles} />
                <LengthToggle />
              </>
            )}
          </LengthsWrapper>
        </DimensionContainer>
      </StyledCard>
    </AppWrapper>
  );
};
